import React from "react";
import PhoneInput, {
  getAustralianNationalNumber,
  isValidAustralianMobile,
  toAustralianE164,
} from "./PhoneInput";

const AustralianPhoneInput = ({ inputClassName, className, ...props }) => (
  <PhoneInput {...props} className={className || inputClassName || ""} />
);

export {
  getAustralianNationalNumber,
  isValidAustralianMobile,
  toAustralianE164,
};

export default AustralianPhoneInput;
